import { Serializable } from "@interfaces/serializable";

export interface EnsayoDTO {
  id: number;
  slug: string;
  codigo: string;
  nombre: string;
  roi: number;
  dosis: string;
  momento_de_aplicacion: string;
  fecha: string;
  imagen: string;
  pais: string;
  cultivo: number;
  productos: Array<{
    producto: {
      slug: string;
      nombre: string;
    };
    familia: {
      color: string;
    };
  }>;
  resultados: Array<{ valor: string; magnitud: string; descripcion: string }>;
  adjuntos: Array<{ descripcion: string; imagen: string }>;
}

export class Ensayo implements Serializable<Ensayo> {
  id: number;
  slug: string;
  codigo: string;
  nombre: string;
  roi: number;
  dosis: string;
  pais: string;
  cultivo: number;
  momento_de_aplicacion: string;
  fecha: string;
  imagen: string;
  productos: Array<{
    producto: {
      slug: string;
      nombre: string;
    };
    familia: {
      color: string;
    };
  }>;
  resultados: Array<{ valor: string; magnitud: string; descripcion: string }>;
  adjuntos: Array<{ descripcion: string; imagen: string }>;

  deserialize(input: EnsayoDTO): Ensayo {
    this.id = input.id || 0;
    this.slug = input.slug || "";
    this.codigo = input.codigo || "";
    this.nombre = input.nombre || "";
    this.roi = input.roi || 0;
    this.pais = input.pais || "";
    this.cultivo = input.cultivo || 0;
    this.dosis = input.dosis || "";
    this.momento_de_aplicacion = input.momento_de_aplicacion || "";
    this.fecha = input.fecha || "";
    this.imagen = input.imagen || "";
    this.productos = input.productos
      ? input.productos.map((x) => {
          return {
            familia: { color: x.familia.color || "" },
            producto: {
              slug: x.producto.slug || "",
              nombre: x.producto.nombre || "",
            },
          };
        })
      : [];
    this.resultados = input.resultados || [];
    this.adjuntos = input.adjuntos || [];
    return this;
  }

  deserializeArray(input: EnsayoDTO[]): Ensayo[] {
    return input.map((input) => new Ensayo().deserialize(input));
  }
}
